const error = {
  namespaced: true,
  state: {
    code: -1,
    message: '',
  },
  getters: {
    getError: (state) => {
      return state
    },
    getHasError: (state) => {
      return state.code >= 0
    },
    getErrorCode: (state) => {
      return state.code
    },
    getHasUnauthrizedError: (state) => {
      return state.code === 401
    },
    getHasNotFoundError: (state) => {
      return state.code === 404
    },
    getHasUnhandledError: (_state_, getters) => {
      const hasUnauthrizedError = getters.getHasUnauthrizedError
      const hasNotFoundError = getters.getHasNotFoundError
      const hasError = getters.getHasError
      return hasError && !hasUnauthrizedError && !hasNotFoundError
    },
    getHasCriticalError: (_state_, getters) => {
      const hasUnhandledError = getters.getHasUnhandledError
      const hasUnauthrizedError = getters.getHasUnauthrizedError
      return hasUnhandledError || hasUnauthrizedError
    },
    getErrorMessage: (state) => {
      return state.message
    },
  },
  actions: {
    setError: ({ commit }, error) => {
      commit('setError', error)
    },
    clearError: ({ commit }) => {
      commit('clearError')
    },
  },
  mutations: {
    setError(state, error) {
      state.code = error.code
      state.message = error.message
    },
    clearError(state) {
      state.code = -1
      state.message = ''
    },
  },
}

export default error
